import { SiteFooter } from "@replicate/ui";
import DarkModeToggle, { type Theme } from "../dark-mode-toggle";
import PlatformStatus from "../platform-status";

export function Footer({
  theme,
  showBrandFlourish,
  showExpandedFooter,
}: {
  theme: Theme;
  showBrandFlourish?: boolean;
  showExpandedFooter?: boolean;
}) {
  return (
    <SiteFooter
      showBrandFlourish={showBrandFlourish}
      showExpandedFooter={showExpandedFooter}
      platformStatus={<PlatformStatus />}
      darkModeToggle={<DarkModeToggle theme={theme} />}
    />
  );
}
